import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  InterestAction,
  PhotoreqAction,
  ShortlistAction,
  SearchAction,
} from "../../store/actions";

import Cardloader from "../../components/loader/cardloader";
import DashboardCard from "../../components/dashboardcard/dashboardcard";
import CardBottomButton from "../../components/dashboardcard/cardbottombutton";
import {
  VioletButton,
  VioletButtonLarge,
  PrimaryButton,
} from "../../components/button";
import Carousel from "../../components/carousel/carousel";
import StartChattingProfile from "../../components/startchatting/startchattingprofile";

import images from "../../assets";

import "./styles.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    recommendedMatches,
    isRecommendedLoading,
    matchOfTheDay,
    isModLoading,
  } = useSelector((state) => state.search);
  const { newMembers, isLoading } = useSelector((state) => state.newMembers);
  const { profileViewer } = useSelector((state) => state.profileView);
  const profileViewerLoading = useSelector(
    (state) => state.profileView?.isLoading
  );
  const { interestsAll } = useSelector((state) => state.interests);
  const { photoreqAll } = useSelector((state) => state.photoreq);
  const { shortlistsAll } = useSelector((state) => state.shortlists);
  const profileData = useSelector((state) => state.profile?.profile);

  const [recommendedArray, setRecommendedArray] = useState([]);

  useEffect(() => {
    const array = [];
    if (matchOfTheDay && matchOfTheDay?.username) {
      array.push({ ...matchOfTheDay, matchOfTheDay: true });
    }
    if (recommendedMatches?.length > 0) {
      array.push(...recommendedMatches);
    }
    setRecommendedArray(array);
  }, [recommendedMatches, matchOfTheDay]);

  useEffect(() => {
    const payload = {
      username: profileData?.username,
      from: 0,
      size: 11,
    };
    if (profileData?.username) {
      dispatch(SearchAction.recommendedSearch(payload));
      dispatch(SearchAction.getMod());
    }
  }, [profileData]);

  const handleSendInterest = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(InterestAction.sendInterest(payload));
  };

  const handleShortlist = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(ShortlistAction.sendShortlist(payload));
  };

  const handleSendPhotoReq = (id) => {
    const payload = {
      receiverId: id,
    };
    dispatch(PhotoreqAction.sendPhotoreq(payload));
  };
  return (
    <>
      <div className="recommended-container recommended-container-mobile">
        <div className="start-chatting hidden">
          <div className="chatting-heading">
            <h3>Start Chatting</h3>
          </div>
          <div className="chatting-profile-logo">
            <StartChattingProfile image={images.defaultMaleIcon} />
            <StartChattingProfile image={images.defaultFemaleIcon} />
            <StartChattingProfile image={images.defaultMaleIcon} />
          </div>
        </div>

        <div className="header-container gap-1">
          <h1 className="section-heading">Recommended Matches</h1>
          <VioletButton
            onClick={() => navigate("/match-preference")}
            text="Improve Match"
          />
        </div>
        {isRecommendedLoading || isModLoading ? (
          <Cardloader />
        ) : (
          <>
            {recommendedArray?.length > 0 ? (
              <div className="recommended-matches-container">
                {recommendedArray?.slice(0, 11)?.map((item, index) => {
                  const interestSent = interestsAll?.some(
                    (profile) => profile.receiverId === item?.username
                  );

                  const photoreqSent = photoreqAll?.some(
                    (profile) => profile.receiverId === item?.username
                  );
                  const shortlistSent = shortlistsAll?.find(
                    (profile) => profile.receiverId === item?.username
                  );

                  return (
                    <DashboardCard
                      item={item}
                      index={index}
                      key={index}
                      redirectedfrom="recommendedSearch"
                    >
                      {item?.matchOfTheDay && (
                        <CardBottomButton
                          icon={images.cardButtonTick}
                          onClick={() => handleShortlist(item?.username)}
                          title="Shortlist"
                          disabled={shortlistSent ? true : false}
                        />
                      )}
                      <CardBottomButton
                        icon={images.cardMessage}
                        onClick={() =>
                          navigate(
                            `/messages?username=${item?.username}&firstName=${item?.firstName}&lastName=${item?.lastName}&photo=${item?.profilePicture}`
                          )
                        }
                        title="Send Message"
                      />
                      <CardBottomButton
                        icon={images.cardPhotoReq}
                        onClick={() => handleSendPhotoReq(item?.username)}
                        title="Send Photo Request"
                        disabled={photoreqSent ? true : false}
                      />
                      <CardBottomButton
                        icon={images.cardmatch}
                        onClick={() => handleSendInterest(item?.username)}
                        title="Send Interest"
                        disabled={interestSent ? true : false}
                      />
                    </DashboardCard>
                  );
                })}
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
                <img
                  src={images.noSearchIcon}
                  alt="no notifications"
                  className="h-[160px] lg:h-full"
                />
                <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
                  No Matches Yet
                </div>
                <p className="text-[14px] text-center max-w-[500px]">
                  We’re still searching for the right matches for you. To help
                  us recommend better profiles, please update your profile and
                  match preferences.
                </p>
                <PrimaryButton
                  text={"Update My Preferences"}
                  style={{ width: "250px" }}
                  onClick={() => navigate("/match-preference")}
                />
              </div>
            )}
          </>
        )}
        {recommendedArray?.length > 0 && (
          <div className="view-all-button-container">
            <VioletButtonLarge
              onClick={() => navigate("/recommended-matches")}
              text="View All Matches"
            />
          </div>
        )}
      </div>

      <div style={{ height: "32px" }}></div>
      <div className="recommended-container">
        <div className="header-container">
          <h1 className="section-heading">Profile viewers</h1>
          <div>
            <VioletButton
              text="View All"
              onClick={() => navigate("/profile-viewers")}
            />
          </div>
        </div>
        {profileViewerLoading ? (
          <Cardloader />
        ) : profileViewer?.length > 0 ? (
          <Carousel data={profileViewer} redirectedfrom="profileViewer" />
        ) : (
          <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
            <img
              src={images.noActivityIcon}
              alt="no notifications"
              className="h-[160px] lg:h-full"
            />
            <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
              No One Viewed You Yet
            </div>
            <p className="text-[14px] text-center max-w-[500px]">
              Once someone checks out your profile, you’ll see them here.
            </p>
          </div>
        )}
      </div>
      <div style={{ height: "32px" }}></div>
      <div className="recommended-container">
        <div className="header-container">
          <h1 className="section-heading">New Members</h1>
          <div>
            <VioletButton
              text="View All"
              onClick={() => navigate("/new-members")}
            />
          </div>
        </div>
        {isLoading ? (
          <Cardloader />
        ) : newMembers?.length > 0 ? (
          <Carousel data={newMembers} redirectedfrom="newMembers" />
        ) : (
          <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
            <img
              src={images.noActivityIcon}
              alt="no notifications"
              className="h-[160px] lg:h-full"
            />
            <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
              No Result Found
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
